import { createContext } from "react";

import type { PartnerProfile, PartnerSession } from "@/types/partner";

export type LoginOutcome =
  | { status: "authenticated" }
  | { status: "needs_password_reset"; email: string; message: string };

export type AuthContextValue = {
  session: PartnerSession | null;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<LoginOutcome>;
  logout: () => void;
  refreshProfile: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

export type { PartnerProfile, PartnerSession };
